import { render, staticRenderFns } from "./VideoPlyrSplashPlayer.vue?vue&type=template&id=95d34980&"
import script from "./VideoPlyrSplashPlayer.vue?vue&type=script&lang=js&"
export * from "./VideoPlyrSplashPlayer.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlyrSplashPlayer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports